export const isoCountries = [
  {
    name: 'Afghanistan',
    'alpha-2': 'AF',
    'country-code': '004'
  },
  {
    name: 'Åland Islands',
    'alpha-2': 'AX',
    'country-code': '248'
  },
  {
    name: 'Albania',
    'alpha-2': 'AL',
    'country-code': '008'
  },
  {
    name: 'Algeria',
    'alpha-2': 'DZ',
    'country-code': '012'
  },
  {
    name: 'American Samoa',
    'alpha-2': 'AS',
    'country-code': '016'
  },
  {
    name: 'Andorra',
    'alpha-2': 'AD',
    'country-code': '020'
  },
  {
    name: 'Angola',
    'alpha-2': 'AO',
    'country-code': '024'
  },
  {
    name: 'Anguilla',
    'alpha-2': 'AI',
    'country-code': '660'
  },
  {
    name: 'Antarctica',
    'alpha-2': 'AQ',
    'country-code': '010'
  },
  {
    name: 'Antigua and Barbuda',
    'alpha-2': 'AG',
    'country-code': '028'
  },
  {
    name: 'Argentina',
    'alpha-2': 'AR',
    'country-code': '032'
  },
  {
    name: 'Armenia',
    'alpha-2': 'AM',
    'country-code': '051'
  },
  {
    name: 'Aruba',
    'alpha-2': 'AW',
    'country-code': '533'
  },
  {
    name: 'Australia',
    'alpha-2': 'AU',
    'country-code': '036'
  },
  {
    name: 'Austria',
    'alpha-2': 'AT',
    'country-code': '040'
  },
  {
    name: 'Azerbaijan',
    'alpha-2': 'AZ',
    'country-code': '031'
  },
  {
    name: 'Bahamas',
    'alpha-2': 'BS',
    'country-code': '044'
  },
  {
    name: 'Bahrain',
    'alpha-2': 'BH',
    'country-code': '048'
  },
  {
    name: 'Bangladesh',
    'alpha-2': 'BD',
    'country-code': '050'
  },
  {
    name: 'Barbados',
    'alpha-2': 'BB',
    'country-code': '052'
  },
  {
    name: 'Belarus',
    'alpha-2': 'BY',
    'country-code': '112'
  },
  {
    name: 'Belgium',
    'alpha-2': 'BE',
    'country-code': '056'
  },
  {
    name: 'Belize',
    'alpha-2': 'BZ',
    'country-code': '084'
  },
  {
    name: 'Benin',
    'alpha-2': 'BJ',
    'country-code': '204'
  },
  {
    name: 'Bermuda',
    'alpha-2': 'BM',
    'country-code': '060'
  },
  {
    name: 'Bhutan',
    'alpha-2': 'BT',
    'country-code': '064'
  },
  {
    name: 'Bolivia',
    'alpha-2': 'BO',
    'country-code': '068'
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    'alpha-2': 'BQ',
    'country-code': '535'
  },
  {
    name: 'Bosnia and Herzegovina',
    'alpha-2': 'BA',
    'country-code': '070'
  },
  {
    name: 'Botswana',
    'alpha-2': 'BW',
    'country-code': '072'
  },
  {
    name: 'Bouvet Island',
    'alpha-2': 'BV',
    'country-code': '074'
  },
  {
    name: 'Brazil',
    'alpha-2': 'BR',
    'country-code': '076'
  },
  {
    name: 'British Indian Ocean Territory',
    'alpha-2': 'IO',
    'country-code': '086'
  },
  {
    name: 'Brunei Darussalam',
    'alpha-2': 'BN',
    'country-code': '096'
  },
  {
    name: 'Bulgaria',
    'alpha-2': 'BG',
    'country-code': '100'
  },
  {
    name: 'Burkina Faso',
    'alpha-2': 'BF',
    'country-code': '854'
  },
  {
    name: 'Burundi',
    'alpha-2': 'BI',
    'country-code': '108'
  },
  {
    name: 'Cabo Verde',
    'alpha-2': 'CV',
    'country-code': '132'
  },
  {
    name: 'Cambodia',
    'alpha-2': 'KH',
    'country-code': '116'
  },
  {
    name: 'Cameroon',
    'alpha-2': 'CM',
    'country-code': '120'
  },
  {
    name: 'Canada',
    'alpha-2': 'CA',
    'country-code': '124'
  },
  {
    name: 'Cayman Islands',
    'alpha-2': 'KY',
    'country-code': '136'
  },
  {
    name: 'Central African Republic',
    'alpha-2': 'CF',
    'country-code': '140'
  },
  {
    name: 'Chad',
    'alpha-2': 'TD',
    'country-code': '148'
  },
  {
    name: 'Chile',
    'alpha-2': 'CL',
    'country-code': '152'
  },
  {
    name: 'China',
    'alpha-2': 'CN',
    'country-code': '156'
  },
  {
    name: 'Christmas Island',
    'alpha-2': 'CX',
    'country-code': '162'
  },
  {
    name: 'Cocos (Keeling) Islands',
    'alpha-2': 'CC',
    'country-code': '166'
  },
  {
    name: 'Colombia',
    'alpha-2': 'CO',
    'country-code': '170'
  },
  {
    name: 'Comoros',
    'alpha-2': 'KM',
    'country-code': '174'
  },
  {
    name: 'Congo',
    'alpha-2': 'CG',
    'country-code': '178'
  },
  {
    name: 'Congo, Democratic Republic of the',
    'alpha-2': 'CD',
    'country-code': '180'
  },
  {
    name: 'Cook Islands',
    'alpha-2': 'CK',
    'country-code': '184'
  },
  {
    name: 'Costa Rica',
    'alpha-2': 'CR',
    'country-code': '188'
  },
  {
    name: "Côte d'Ivoire",
    'alpha-2': 'CI',
    'country-code': '384'
  },
  {
    name: 'Croatia',
    'alpha-2': 'HR',
    'country-code': '191'
  },
  {
    name: 'Cuba',
    'alpha-2': 'CU',
    'country-code': '192'
  },
  {
    name: 'Curaçao',
    'alpha-2': 'CW',
    'country-code': '531'
  },
  {
    name: 'Cyprus',
    'alpha-2': 'CY',
    'country-code': '196'
  },
  {
    name: 'Czechia',
    'alpha-2': 'CZ',
    'country-code': '203'
  },
  {
    name: 'Denmark',
    'alpha-2': 'DK',
    'country-code': '208'
  },
  {
    name: 'Djibouti',
    'alpha-2': 'DJ',
    'country-code': '262'
  },
  {
    name: 'Dominica',
    'alpha-2': 'DM',
    'country-code': '212'
  },
  {
    name: 'Dominican Republic',
    'alpha-2': 'DO',
    'country-code': '214'
  },
  {
    name: 'Ecuador',
    'alpha-2': 'EC',
    'country-code': '218'
  },
  {
    name: 'Egypt',
    'alpha-2': 'EG',
    'country-code': '818'
  },
  {
    name: 'El Salvador',
    'alpha-2': 'SV',
    'country-code': '222'
  },
  {
    name: 'Equatorial Guinea',
    'alpha-2': 'GQ',
    'country-code': '226'
  },
  {
    name: 'Eritrea',
    'alpha-2': 'ER',
    'country-code': '232'
  },
  {
    name: 'Estonia',
    'alpha-2': 'EE',
    'country-code': '233'
  },
  {
    name: 'Eswatini',
    'alpha-2': 'SZ',
    'country-code': '748'
  },
  {
    name: 'Ethiopia',
    'alpha-2': 'ET',
    'country-code': '231'
  },
  {
    name: 'Falkland Islands (Malvinas)',
    'alpha-2': 'FK',
    'country-code': '238'
  },
  {
    name: 'Faroe Islands',
    'alpha-2': 'FO',
    'country-code': '234'
  },
  {
    name: 'Fiji',
    'alpha-2': 'FJ',
    'country-code': '242'
  },
  {
    name: 'Finland',
    'alpha-2': 'FI',
    'country-code': '246'
  },
  {
    name: 'France',
    'alpha-2': 'FR',
    'country-code': '250'
  },
  {
    name: 'French Guiana',
    'alpha-2': 'GF',
    'country-code': '254'
  },
  {
    name: 'French Polynesia',
    'alpha-2': 'PF',
    'country-code': '258'
  },
  {
    name: 'French Southern Territories',
    'alpha-2': 'TF',
    'country-code': '260'
  },
  {
    name: 'Gabon',
    'alpha-2': 'GA',
    'country-code': '266'
  },
  {
    name: 'Gambia',
    'alpha-2': 'GM',
    'country-code': '270'
  },
  {
    name: 'Georgia',
    'alpha-2': 'GE',
    'country-code': '268'
  },
  {
    name: 'Germany',
    'alpha-2': 'DE',
    'country-code': '276'
  },
  {
    name: 'Ghana',
    'alpha-2': 'GH',
    'country-code': '288'
  },
  {
    name: 'Gibraltar',
    'alpha-2': 'GI',
    'country-code': '292'
  },
  {
    name: 'Greece',
    'alpha-2': 'GR',
    'country-code': '300'
  },
  {
    name: 'Greenland',
    'alpha-2': 'GL',
    'country-code': '304'
  },
  {
    name: 'Grenada',
    'alpha-2': 'GD',
    'country-code': '308'
  },
  {
    name: 'Guadeloupe',
    'alpha-2': 'GP',
    'country-code': '312'
  },
  {
    name: 'Guam',
    'alpha-2': 'GU',
    'country-code': '316'
  },
  {
    name: 'Guatemala',
    'alpha-2': 'GT',
    'country-code': '320'
  },
  {
    name: 'Guernsey',
    'alpha-2': 'GG',
    'country-code': '831'
  },
  {
    name: 'Guinea',
    'alpha-2': 'GN',
    'country-code': '324'
  },
  {
    name: 'Guinea-Bissau',
    'alpha-2': 'GW',
    'country-code': '624'
  },
  {
    name: 'Guyana',
    'alpha-2': 'GY',
    'country-code': '328'
  },
  {
    name: 'Haiti',
    'alpha-2': 'HT',
    'country-code': '332'
  },
  {
    name: 'Heard Island and McDonald Islands',
    'alpha-2': 'HM',
    'country-code': '334'
  },
  {
    name: 'Holy See',
    'alpha-2': 'VA',
    'country-code': '336'
  },
  {
    name: 'Honduras',
    'alpha-2': 'HN',
    'country-code': '340'
  },
  {
    name: 'Hong Kong',
    'alpha-2': 'HK',
    'country-code': '344'
  },
  {
    name: 'Hungary',
    'alpha-2': 'HU',
    'country-code': '348'
  },
  {
    name: 'Iceland',
    'alpha-2': 'IS',
    'country-code': '352'
  },
  {
    name: 'India',
    'alpha-2': 'IN',
    'country-code': '356'
  },
  {
    name: 'Indonesia',
    'alpha-2': 'ID',
    'country-code': '360'
  },
  {
    name: 'Iran',
    'alpha-2': 'IR',
    'country-code': '364'
  },
  {
    name: 'Iraq',
    'alpha-2': 'IQ',
    'country-code': '368'
  },
  {
    name: 'Ireland',
    'alpha-2': 'IE',
    'country-code': '372'
  },
  {
    name: 'Isle of Man',
    'alpha-2': 'IM',
    'country-code': '833'
  },
  {
    name: 'Israel',
    'alpha-2': 'IL',
    'country-code': '376'
  },
  {
    name: 'Italy',
    'alpha-2': 'IT',
    'country-code': '380'
  },
  {
    name: 'Jamaica',
    'alpha-2': 'JM',
    'country-code': '388'
  },
  {
    name: 'Japan',
    'alpha-2': 'JP',
    'country-code': '392'
  },
  {
    name: 'Jersey',
    'alpha-2': 'JE',
    'country-code': '832'
  },
  {
    name: 'Jordan',
    'alpha-2': 'JO',
    'country-code': '400'
  },
  {
    name: 'Kazakhstan',
    'alpha-2': 'KZ',
    'country-code': '398'
  },
  {
    name: 'Kenya',
    'alpha-2': 'KE',
    'country-code': '404'
  },
  {
    name: 'Kiribati',
    'alpha-2': 'KI',
    'country-code': '296'
  },
  {
    name: "Korea, Democratic People's Republic of",
    'alpha-2': 'KP',
    'country-code': '408'
  },
  {
    name: 'Korea, Republic of',
    'alpha-2': 'KR',
    'country-code': '410'
  },
  {
    name: 'Kuwait',
    'alpha-2': 'KW',
    'country-code': '414'
  },
  {
    name: 'Kyrgyzstan',
    'alpha-2': 'KG',
    'country-code': '417'
  },
  {
    name: "Lao People's Democratic Republic",
    'alpha-2': 'LA',
    'country-code': '418'
  },
  {
    name: 'Latvia',
    'alpha-2': 'LV',
    'country-code': '428'
  },
  {
    name: 'Lebanon',
    'alpha-2': 'LB',
    'country-code': '422'
  },
  {
    name: 'Lesotho',
    'alpha-2': 'LS',
    'country-code': '426'
  },
  {
    name: 'Liberia',
    'alpha-2': 'LR',
    'country-code': '430'
  },
  {
    name: 'Libya',
    'alpha-2': 'LY',
    'country-code': '434'
  },
  {
    name: 'Liechtenstein',
    'alpha-2': 'LI',
    'country-code': '438'
  },
  {
    name: 'Lithuania',
    'alpha-2': 'LT',
    'country-code': '440'
  },
  {
    name: 'Luxembourg',
    'alpha-2': 'LU',
    'country-code': '442'
  },
  {
    name: 'Macao',
    'alpha-2': 'MO',
    'country-code': '446'
  },
  {
    name: 'Madagascar',
    'alpha-2': 'MG',
    'country-code': '450'
  },
  {
    name: 'Malawi',
    'alpha-2': 'MW',
    'country-code': '454'
  },
  {
    name: 'Malaysia',
    'alpha-2': 'MY',
    'country-code': '458'
  },
  {
    name: 'Maldives',
    'alpha-2': 'MV',
    'country-code': '462'
  },
  {
    name: 'Mali',
    'alpha-2': 'ML',
    'country-code': '466'
  },
  {
    name: 'Malta',
    'alpha-2': 'MT',
    'country-code': '470'
  },
  {
    name: 'Marshall Islands',
    'alpha-2': 'MH',
    'country-code': '584'
  },
  {
    name: 'Martinique',
    'alpha-2': 'MQ',
    'country-code': '474'
  },
  {
    name: 'Mauritania',
    'alpha-2': 'MR',
    'country-code': '478'
  },
  {
    name: 'Mauritius',
    'alpha-2': 'MU',
    'country-code': '480'
  },
  {
    name: 'Mayotte',
    'alpha-2': 'YT',
    'country-code': '175'
  },
  {
    name: 'Mexico',
    'alpha-2': 'MX',
    'country-code': '484'
  },
  {
    name: 'Micronesia',
    'alpha-2': 'FM',
    'country-code': '583'
  },
  {
    name: 'Moldova',
    'alpha-2': 'MD',
    'country-code': '498'
  },
  {
    name: 'Monaco',
    'alpha-2': 'MC',
    'country-code': '492'
  },
  {
    name: 'Mongolia',
    'alpha-2': 'MN',
    'country-code': '496'
  },
  {
    name: 'Montenegro',
    'alpha-2': 'ME',
    'country-code': '499'
  },
  {
    name: 'Montserrat',
    'alpha-2': 'MS',
    'country-code': '500'
  },
  {
    name: 'Morocco',
    'alpha-2': 'MA',
    'country-code': '504'
  },
  {
    name: 'Mozambique',
    'alpha-2': 'MZ',
    'country-code': '508'
  },
  {
    name: 'Myanmar',
    'alpha-2': 'MM',
    'country-code': '104'
  },
  {
    name: 'Namibia',
    'alpha-2': 'NA',
    'country-code': '516'
  },
  {
    name: 'Nauru',
    'alpha-2': 'NR',
    'country-code': '520'
  },
  {
    name: 'Nepal',
    'alpha-2': 'NP',
    'country-code': '524'
  },
  {
    name: 'Netherlands',
    'alpha-2': 'NL',
    'country-code': '528'
  },
  {
    name: 'New Caledonia',
    'alpha-2': 'NC',
    'country-code': '540'
  },
  {
    name: 'New Zealand',
    'alpha-2': 'NZ',
    'country-code': '554'
  },
  {
    name: 'Nicaragua',
    'alpha-2': 'NI',
    'country-code': '558'
  },
  {
    name: 'Niger',
    'alpha-2': 'NE',
    'country-code': '562'
  },
  {
    name: 'Nigeria',
    'alpha-2': 'NG',
    'country-code': '566'
  },
  {
    name: 'Niue',
    'alpha-2': 'NU',
    'country-code': '570'
  },
  {
    name: 'Norfolk Island',
    'alpha-2': 'NF',
    'country-code': '574'
  },
  {
    name: 'North Macedonia',
    'alpha-2': 'MK',
    'country-code': '807'
  },
  {
    name: 'Northern Mariana Islands',
    'alpha-2': 'MP',
    'country-code': '580'
  },
  {
    name: 'Norway',
    'alpha-2': 'NO',
    'country-code': '578'
  },
  {
    name: 'Oman',
    'alpha-2': 'OM',
    'country-code': '512'
  },
  {
    name: 'Pakistan',
    'alpha-2': 'PK',
    'country-code': '586'
  },
  {
    name: 'Palau',
    'alpha-2': 'PW',
    'country-code': '585'
  },
  {
    name: 'Palestine, State of',
    'alpha-2': 'PS',
    'country-code': '275'
  },
  {
    name: 'Panama',
    'alpha-2': 'PA',
    'country-code': '591'
  },
  {
    name: 'Papua New Guinea',
    'alpha-2': 'PG',
    'country-code': '598'
  },
  {
    name: 'Paraguay',
    'alpha-2': 'PY',
    'country-code': '600'
  },
  {
    name: 'Peru',
    'alpha-2': 'PE',
    'country-code': '604'
  },
  {
    name: 'Philippines',
    'alpha-2': 'PH',
    'country-code': '608'
  },
  {
    name: 'Pitcairn',
    'alpha-2': 'PN',
    'country-code': '612'
  },
  {
    name: 'Poland',
    'alpha-2': 'PL',
    'country-code': '616'
  },
  {
    name: 'Portugal',
    'alpha-2': 'PT',
    'country-code': '620'
  },
  {
    name: 'Puerto Rico',
    'alpha-2': 'PR',
    'country-code': '630'
  },
  {
    name: 'Qatar',
    'alpha-2': 'QA',
    'country-code': '634'
  },
  {
    name: 'Réunion',
    'alpha-2': 'RE',
    'country-code': '638'
  },
  {
    name: 'Romania',
    'alpha-2': 'RO',
    'country-code': '642'
  },
  {
    name: 'Russian Federation',
    'alpha-2': 'RU',
    'country-code': '643'
  },
  {
    name: 'Rwanda',
    'alpha-2': 'RW',
    'country-code': '646'
  },
  {
    name: 'Saint Barthélemy',
    'alpha-2': 'BL',
    'country-code': '652'
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    'alpha-2': 'SH',
    'country-code': '654'
  },
  {
    name: 'Saint Kitts and Nevis',
    'alpha-2': 'KN',
    'country-code': '659'
  },
  {
    name: 'Saint Lucia',
    'alpha-2': 'LC',
    'country-code': '662'
  },
  {
    name: 'Saint Martin (French part)',
    'alpha-2': 'MF',
    'country-code': '663'
  },
  {
    name: 'Saint Pierre and Miquelon',
    'alpha-2': 'PM',
    'country-code': '666'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    'alpha-2': 'VC',
    'country-code': '670'
  },
  {
    name: 'Samoa',
    'alpha-2': 'WS',
    'country-code': '882'
  },
  {
    name: 'San Marino',
    'alpha-2': 'SM',
    'country-code': '674'
  },
  {
    name: 'Sao Tome and Principe',
    'alpha-2': 'ST',
    'country-code': '678'
  },
  {
    name: 'Saudi Arabia',
    'alpha-2': 'SA',
    'country-code': '682'
  },
  {
    name: 'Senegal',
    'alpha-2': 'SN',
    'country-code': '686'
  },
  {
    name: 'Serbia',
    'alpha-2': 'RS',
    'country-code': '688'
  },
  {
    name: 'Seychelles',
    'alpha-2': 'SC',
    'country-code': '690'
  },
  {
    name: 'Sierra Leone',
    'alpha-2': 'SL',
    'country-code': '694'
  },
  {
    name: 'Singapore',
    'alpha-2': 'SG',
    'country-code': '702'
  },
  {
    name: 'Sint Maarten (Dutch part)',
    'alpha-2': 'SX',
    'country-code': '534'
  },
  {
    name: 'Slovakia',
    'alpha-2': 'SK',
    'country-code': '703'
  },
  {
    name: 'Slovenia',
    'alpha-2': 'SI',
    'country-code': '705'
  },
  {
    name: 'Solomon Islands',
    'alpha-2': 'SB',
    'country-code': '090'
  },
  {
    name: 'Somalia',
    'alpha-2': 'SO',
    'country-code': '706'
  },
  {
    name: 'South Africa',
    'alpha-2': 'ZA',
    'country-code': '710'
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    'alpha-2': 'GS',
    'country-code': '239'
  },
  {
    name: 'South Sudan',
    'alpha-2': 'SS',
    'country-code': '728'
  },
  {
    name: 'Spain',
    'alpha-2': 'ES',
    'country-code': '724'
  },
  {
    name: 'Sri Lanka',
    'alpha-2': 'LK',
    'country-code': '144'
  },
  {
    name: 'Sudan',
    'alpha-2': 'SD',
    'country-code': '729'
  },
  {
    name: 'Suriname',
    'alpha-2': 'SR',
    'country-code': '740'
  },
  {
    name: 'Svalbard and Jan Mayen',
    'alpha-2': 'SJ',
    'country-code': '744'
  },
  {
    name: 'Sweden',
    'alpha-2': 'SE',
    'country-code': '752'
  },
  {
    name: 'Switzerland',
    'alpha-2': 'CH',
    'country-code': '756'
  },
  {
    name: 'Syrian Arab Republic',
    'alpha-2': 'SY',
    'country-code': '760'
  },
  {
    name: 'Taiwan',
    'alpha-2': 'TW',
    'country-code': '158'
  },
  {
    name: 'Tajikistan',
    'alpha-2': 'TJ',
    'country-code': '762'
  },
  {
    name: 'Tanzania',
    'alpha-2': 'TZ',
    'country-code': '834'
  },
  {
    name: 'Thailand',
    'alpha-2': 'TH',
    'country-code': '764'
  },
  {
    name: 'Timor-Leste',
    'alpha-2': 'TL',
    'country-code': '626'
  },
  {
    name: 'Togo',
    'alpha-2': 'TG',
    'country-code': '768'
  },
  {
    name: 'Tokelau',
    'alpha-2': 'TK',
    'country-code': '772'
  },
  {
    name: 'Tonga',
    'alpha-2': 'TO',
    'country-code': '776'
  },
  {
    name: 'Trinidad and Tobago',
    'alpha-2': 'TT',
    'country-code': '780'
  },
  {
    name: 'Tunisia',
    'alpha-2': 'TN',
    'country-code': '788'
  },
  {
    name: 'Turkey',
    'alpha-2': 'TR',
    'country-code': '792'
  },
  {
    name: 'Turkmenistan',
    'alpha-2': 'TM',
    'country-code': '795'
  },
  {
    name: 'Turks and Caicos Islands',
    'alpha-2': 'TC',
    'country-code': '796'
  },
  {
    name: 'Tuvalu',
    'alpha-2': 'TV',
    'country-code': '798'
  },
  {
    name: 'Uganda',
    'alpha-2': 'UG',
    'country-code': '800'
  },
  {
    name: 'Ukraine',
    'alpha-2': 'UA',
    'country-code': '804'
  },
  {
    name: 'United Arab Emirates',
    'alpha-2': 'AE',
    'country-code': '784'
  },
  {
    name: 'United Kingdom of Great Britain and Northern Ireland',
    'alpha-2': 'GB',
    'country-code': '826'
  },
  {
    name: 'United States of America',
    'alpha-2': 'US',
    'country-code': '840'
  },
  {
    name: 'United States Minor Outlying Islands',
    'alpha-2': 'UM',
    'country-code': '581'
  },
  {
    name: 'Uruguay',
    'alpha-2': 'UY',
    'country-code': '858'
  },
  {
    name: 'Uzbekistan',
    'alpha-2': 'UZ',
    'country-code': '860'
  },
  {
    name: 'Vanuatu',
    'alpha-2': 'VU',
    'country-code': '548'
  },
  {
    name: 'Venezuela',
    'alpha-2': 'VE',
    'country-code': '862'
  },
  {
    name: 'Viet Nam',
    'alpha-2': 'VN',
    'country-code': '704'
  },
  {
    name: 'Virgin Islands (British)',
    'alpha-2': 'VG',
    'country-code': '092'
  },
  {
    name: 'Virgin Islands (U.S.)',
    'alpha-2': 'VI',
    'country-code': '850'
  },
  {
    name: 'Wallis and Futuna',
    'alpha-2': 'WF',
    'country-code': '876'
  },
  {
    name: 'Western Sahara',
    'alpha-2': 'EH',
    'country-code': '732'
  },
  {
    name: 'Yemen',
    'alpha-2': 'YE',
    'country-code': '887'
  },
  {
    name: 'Zambia',
    'alpha-2': 'ZM',
    'country-code': '894'
  },
  {
    name: 'Zimbabwe',
    'alpha-2': 'ZW',
    'country-code': '716'
  }
];

export const countriesOptions = [
  {
    label: 'Afghanistan',
    value: 'AF'
  },
  {
    label: 'Åland Islands',
    value: 'AX'
  },
  {
    label: 'Albania',
    value: 'AL'
  },
  {
    label: 'Algeria',
    value: 'DZ'
  },
  {
    label: 'American Samoa',
    value: 'AS'
  },
  {
    label: 'Andorra',
    value: 'AD'
  },
  {
    label: 'Angola',
    value: 'AO'
  },
  {
    label: 'Anguilla',
    value: 'AI'
  },
  {
    label: 'Antarctica',
    value: 'AQ'
  },
  {
    label: 'Antigua and Barbuda',
    value: 'AG'
  },
  {
    label: 'Argentina',
    value: 'AR'
  },
  {
    label: 'Armenia',
    value: 'AM'
  },
  {
    label: 'Aruba',
    value: 'AW'
  },
  {
    label: 'Australia',
    value: 'AU'
  },
  {
    label: 'Austria',
    value: 'AT'
  },
  {
    label: 'Azerbaijan',
    value: 'AZ'
  },
  {
    label: 'Bahamas',
    value: 'BS'
  },
  {
    label: 'Bahrain',
    value: 'BH'
  },
  {
    label: 'Bangladesh',
    value: 'BD'
  },
  {
    label: 'Barbados',
    value: 'BB'
  },
  {
    label: 'Belarus',
    value: 'BY'
  },
  {
    label: 'Belgium',
    value: 'BE'
  },
  {
    label: 'Belize',
    value: 'BZ'
  },
  {
    label: 'Benin',
    value: 'BJ'
  },
  {
    label: 'Bermuda',
    value: 'BM'
  },
  {
    label: 'Bhutan',
    value: 'BT'
  },
  {
    label: 'Bolivia',
    value: 'BO'
  },
  {
    label: 'Bonaire, Sint Eustatius and Saba',
    value: 'BQ'
  },
  {
    label: 'Bosnia and Herzegovina',
    value: 'BA'
  },
  {
    label: 'Botswana',
    value: 'BW'
  },
  {
    label: 'Bouvet Island',
    value: 'BV'
  },
  {
    label: 'Brazil',
    value: 'BR'
  },
  {
    label: 'British Indian Ocean Territory',
    value: 'IO'
  },
  {
    label: 'Brunei Darussalam',
    value: 'BN'
  },
  {
    label: 'Bulgaria',
    value: 'BG'
  },
  {
    label: 'Burkina Faso',
    value: 'BF'
  },
  {
    label: 'Burundi',
    value: 'BI'
  },
  {
    label: 'Cabo Verde',
    value: 'CV'
  },
  {
    label: 'Cambodia',
    value: 'KH'
  },
  {
    label: 'Cameroon',
    value: 'CM'
  },
  {
    label: 'Canada',
    value: 'CA'
  },
  {
    label: 'Cayman Islands',
    value: 'KY'
  },
  {
    label: 'Central African Republic',
    value: 'CF'
  },
  {
    label: 'Chad',
    value: 'TD'
  },
  {
    label: 'Chile',
    value: 'CL'
  },
  {
    label: 'China',
    value: 'CN'
  },
  {
    label: 'Christmas Island',
    value: 'CX'
  },
  {
    label: 'Cocos (Keeling) Islands',
    value: 'CC'
  },
  {
    label: 'Colombia',
    value: 'CO'
  },
  {
    label: 'Comoros',
    value: 'KM'
  },
  {
    label: 'Congo',
    value: 'CG'
  },
  {
    label: 'Congo, Democratic Republic of the',
    value: 'CD'
  },
  {
    label: 'Cook Islands',
    value: 'CK'
  },
  {
    label: 'Costa Rica',
    value: 'CR'
  },
  {
    label: "Côte d'Ivoire",
    value: 'CI'
  },
  {
    label: 'Croatia',
    value: 'HR'
  },
  {
    label: 'Cuba',
    value: 'CU'
  },
  {
    label: 'Curaçao',
    value: 'CW'
  },
  {
    label: 'Cyprus',
    value: 'CY'
  },
  {
    label: 'Czechia',
    value: 'CZ'
  },
  {
    label: 'Denmark',
    value: 'DK'
  },
  {
    label: 'Djibouti',
    value: 'DJ'
  },
  {
    label: 'Dominica',
    value: 'DM'
  },
  {
    label: 'Dominican Republic',
    value: 'DO'
  },
  {
    label: 'Ecuador',
    value: 'EC'
  },
  {
    label: 'Egypt',
    value: 'EG'
  },
  {
    label: 'El Salvador',
    value: 'SV'
  },
  {
    label: 'Equatorial Guinea',
    value: 'GQ'
  },
  {
    label: 'Eritrea',
    value: 'ER'
  },
  {
    label: 'Estonia',
    value: 'EE'
  },
  {
    label: 'Eswatini',
    value: 'SZ'
  },
  {
    label: 'Ethiopia',
    value: 'ET'
  },
  {
    label: 'Falkland Islands (Malvinas)',
    value: 'FK'
  },
  {
    label: 'Faroe Islands',
    value: 'FO'
  },
  {
    label: 'Fiji',
    value: 'FJ'
  },
  {
    label: 'Finland',
    value: 'FI'
  },
  {
    label: 'France',
    value: 'FR'
  },
  {
    label: 'French Guiana',
    value: 'GF'
  },
  {
    label: 'French Polynesia',
    value: 'PF'
  },
  {
    label: 'French Southern Territories',
    value: 'TF'
  },
  {
    label: 'Gabon',
    value: 'GA'
  },
  {
    label: 'Gambia',
    value: 'GM'
  },
  {
    label: 'Georgia',
    value: 'GE'
  },
  {
    label: 'Germany',
    value: 'DE'
  },
  {
    label: 'Ghana',
    value: 'GH'
  },
  {
    label: 'Gibraltar',
    value: 'GI'
  },
  {
    label: 'Greece',
    value: 'GR'
  },
  {
    label: 'Greenland',
    value: 'GL'
  },
  {
    label: 'Grenada',
    value: 'GD'
  },
  {
    label: 'Guadeloupe',
    value: 'GP'
  },
  {
    label: 'Guam',
    value: 'GU'
  },
  {
    label: 'Guatemala',
    value: 'GT'
  },
  {
    label: 'Guernsey',
    value: 'GG'
  },
  {
    label: 'Guinea',
    value: 'GN'
  },
  {
    label: 'Guinea-Bissau',
    value: 'GW'
  },
  {
    label: 'Guyana',
    value: 'GY'
  },
  {
    label: 'Haiti',
    value: 'HT'
  },
  {
    label: 'Heard Island and McDonald Islands',
    value: 'HM'
  },
  {
    label: 'Holy See',
    value: 'VA'
  },
  {
    label: 'Honduras',
    value: 'HN'
  },
  {
    label: 'Hong Kong',
    value: 'HK'
  },
  {
    label: 'Hungary',
    value: 'HU'
  },
  {
    label: 'Iceland',
    value: 'IS'
  },
  {
    label: 'India',
    value: 'IN'
  },
  {
    label: 'Indonesia',
    value: 'ID'
  },
  {
    label: 'Iran',
    value: 'IR'
  },
  {
    label: 'Iraq',
    value: 'IQ'
  },
  {
    label: 'Ireland',
    value: 'IE'
  },
  {
    label: 'Isle of Man',
    value: 'IM'
  },
  {
    label: 'Israel',
    value: 'IL'
  },
  {
    label: 'Italy',
    value: 'IT'
  },
  {
    label: 'Jamaica',
    value: 'JM'
  },
  {
    label: 'Japan',
    value: 'JP'
  },
  {
    label: 'Jersey',
    value: 'JE'
  },
  {
    label: 'Jordan',
    value: 'JO'
  },
  {
    label: 'Kazakhstan',
    value: 'KZ'
  },
  {
    label: 'Kenya',
    value: 'KE'
  },
  {
    label: 'Kiribati',
    value: 'KI'
  },
  {
    label: "Korea, Democratic People's Republic of",
    value: 'KP'
  },
  {
    label: 'Korea, Republic of',
    value: 'KR'
  },
  {
    label: 'Kuwait',
    value: 'KW'
  },
  {
    label: 'Kyrgyzstan',
    value: 'KG'
  },
  {
    label: "Lao People's Democratic Republic",
    value: 'LA'
  },
  {
    label: 'Latvia',
    value: 'LV'
  },
  {
    label: 'Lebanon',
    value: 'LB'
  },
  {
    label: 'Lesotho',
    value: 'LS'
  },
  {
    label: 'Liberia',
    value: 'LR'
  },
  {
    label: 'Libya',
    value: 'LY'
  },
  {
    label: 'Liechtenstein',
    value: 'LI'
  },
  {
    label: 'Lithuania',
    value: 'LT'
  },
  {
    label: 'Luxembourg',
    value: 'LU'
  },
  {
    label: 'Macao',
    value: 'MO'
  },
  {
    label: 'Madagascar',
    value: 'MG'
  },
  {
    label: 'Malawi',
    value: 'MW'
  },
  {
    label: 'Malaysia',
    value: 'MY'
  },
  {
    label: 'Maldives',
    value: 'MV'
  },
  {
    label: 'Mali',
    value: 'ML'
  },
  {
    label: 'Malta',
    value: 'MT'
  },
  {
    label: 'Marshall Islands',
    value: 'MH'
  },
  {
    label: 'Martinique',
    value: 'MQ'
  },
  {
    label: 'Mauritania',
    value: 'MR'
  },
  {
    label: 'Mauritius',
    value: 'MU'
  },
  {
    label: 'Mayotte',
    value: 'YT'
  },
  {
    label: 'Mexico',
    value: 'MX'
  },
  {
    label: 'Micronesia',
    value: 'FM'
  },
  {
    label: 'Moldova',
    value: 'MD'
  },
  {
    label: 'Monaco',
    value: 'MC'
  },
  {
    label: 'Mongolia',
    value: 'MN'
  },
  {
    label: 'Montenegro',
    value: 'ME'
  },
  {
    label: 'Montserrat',
    value: 'MS'
  },
  {
    label: 'Morocco',
    value: 'MA'
  },
  {
    label: 'Mozambique',
    value: 'MZ'
  },
  {
    label: 'Myanmar',
    value: 'MM'
  },
  {
    label: 'Namibia',
    value: 'NA'
  },
  {
    label: 'Nauru',
    value: 'NR'
  },
  {
    label: 'Nepal',
    value: 'NP'
  },
  {
    label: 'Netherlands',
    value: 'NL'
  },
  {
    label: 'New Caledonia',
    value: 'NC'
  },
  {
    label: 'New Zealand',
    value: 'NZ'
  },
  {
    label: 'Nicaragua',
    value: 'NI'
  },
  {
    label: 'Niger',
    value: 'NE'
  },
  {
    label: 'Nigeria',
    value: 'NG'
  },
  {
    label: 'Niue',
    value: 'NU'
  },
  {
    label: 'Norfolk Island',
    value: 'NF'
  },
  {
    label: 'North Macedonia',
    value: 'MK'
  },
  {
    label: 'Northern Mariana Islands',
    value: 'MP'
  },
  {
    label: 'Norway',
    value: 'NO'
  },
  {
    label: 'Oman',
    value: 'OM'
  },
  {
    label: 'Pakistan',
    value: 'PK'
  },
  {
    label: 'Palau',
    value: 'PW'
  },
  {
    label: 'Palestine, State of',
    value: 'PS'
  },
  {
    label: 'Panama',
    value: 'PA'
  },
  {
    label: 'Papua New Guinea',
    value: 'PG'
  },
  {
    label: 'Paraguay',
    value: 'PY'
  },
  {
    label: 'Peru',
    value: 'PE'
  },
  {
    label: 'Philippines',
    value: 'PH'
  },
  {
    label: 'Pitcairn',
    value: 'PN'
  },
  {
    label: 'Poland',
    value: 'PL'
  },
  {
    label: 'Portugal',
    value: 'PT'
  },
  {
    label: 'Puerto Rico',
    value: 'PR'
  },
  {
    label: 'Qatar',
    value: 'QA'
  },
  {
    label: 'Réunion',
    value: 'RE'
  },
  {
    label: 'Romania',
    value: 'RO'
  },
  {
    label: 'Russian Federation',
    value: 'RU'
  },
  {
    label: 'Rwanda',
    value: 'RW'
  },
  {
    label: 'Saint Barthélemy',
    value: 'BL'
  },
  {
    label: 'Saint Helena, Ascension and Tristan da Cunha',
    value: 'SH'
  },
  {
    label: 'Saint Kitts and Nevis',
    value: 'KN'
  },
  {
    label: 'Saint Lucia',
    value: 'LC'
  },
  {
    label: 'Saint Martin (French part)',
    value: 'MF'
  },
  {
    label: 'Saint Pierre and Miquelon',
    value: 'PM'
  },
  {
    label: 'Saint Vincent and the Grenadines',
    value: 'VC'
  },
  {
    label: 'Samoa',
    value: 'WS'
  },
  {
    label: 'San Marino',
    value: 'SM'
  },
  {
    label: 'Sao Tome and Principe',
    value: 'ST'
  },
  {
    label: 'Saudi Arabia',
    value: 'SA'
  },
  {
    label: 'Senegal',
    value: 'SN'
  },
  {
    label: 'Serbia',
    value: 'RS'
  },
  {
    label: 'Seychelles',
    value: 'SC'
  },
  {
    label: 'Sierra Leone',
    value: 'SL'
  },
  {
    label: 'Singapore',
    value: 'SG'
  },
  {
    label: 'Sint Maarten (Dutch part)',
    value: 'SX'
  },
  {
    label: 'Slovakia',
    value: 'SK'
  },
  {
    label: 'Slovenia',
    value: 'SI'
  },
  {
    label: 'Solomon Islands',
    value: 'SB'
  },
  {
    label: 'Somalia',
    value: 'SO'
  },
  {
    label: 'South Africa',
    value: 'ZA'
  },
  {
    label: 'South Georgia and the South Sandwich Islands',
    value: 'GS'
  },
  {
    label: 'South Sudan',
    value: 'SS'
  },
  {
    label: 'Spain',
    value: 'ES'
  },
  {
    label: 'Sri Lanka',
    value: 'LK'
  },
  {
    label: 'Sudan',
    value: 'SD'
  },
  {
    label: 'Suriname',
    value: 'SR'
  },
  {
    label: 'Svalbard and Jan Mayen',
    value: 'SJ'
  },
  {
    label: 'Sweden',
    value: 'SE'
  },
  {
    label: 'Switzerland',
    value: 'CH'
  },
  {
    label: 'Syrian Arab Republic',
    value: 'SY'
  },
  {
    label: 'Taiwan',
    value: 'TW'
  },
  {
    label: 'Tajikistan',
    value: 'TJ'
  },
  {
    label: 'Tanzania',
    value: 'TZ'
  },
  {
    label: 'Thailand',
    value: 'TH'
  },
  {
    label: 'Timor-Leste',
    value: 'TL'
  },
  {
    label: 'Togo',
    value: 'TG'
  },
  {
    label: 'Tokelau',
    value: 'TK'
  },
  {
    label: 'Tonga',
    value: 'TO'
  },
  {
    label: 'Trinidad and Tobago',
    value: 'TT'
  },
  {
    label: 'Tunisia',
    value: 'TN'
  },
  {
    label: 'Turkey',
    value: 'TR'
  },
  {
    label: 'Turkmenistan',
    value: 'TM'
  },
  {
    label: 'Turks and Caicos Islands',
    value: 'TC'
  },
  {
    label: 'Tuvalu',
    value: 'TV'
  },
  {
    label: 'Uganda',
    value: 'UG'
  },
  {
    label: 'Ukraine',
    value: 'UA'
  },
  {
    label: 'United Arab Emirates',
    value: 'AE'
  },
  {
    label: 'United Kingdom of Great Britain and Northern Ireland',
    value: 'GB'
  },
  {
    label: 'United States of America',
    value: 'US'
  },
  {
    label: 'United States Minor Outlying Islands',
    value: 'UM'
  },
  {
    label: 'Uruguay',
    value: 'UY'
  },
  {
    label: 'Uzbekistan',
    value: 'UZ'
  },
  {
    label: 'Vanuatu',
    value: 'VU'
  },
  {
    label: 'Venezuela',
    value: 'VE'
  },
  {
    label: 'Viet Nam',
    value: 'VN'
  },
  {
    label: 'Virgin Islands (British)',
    value: 'VG'
  },
  {
    label: 'Virgin Islands (U.S.)',
    value: 'VI'
  },
  {
    label: 'Wallis and Futuna',
    value: 'WF'
  },
  {
    label: 'Western Sahara',
    value: 'EH'
  },
  {
    label: 'Yemen',
    value: 'YE'
  },
  {
    label: 'Zambia',
    value: 'ZM'
  },
  {
    label: 'Zimbabwe',
    value: 'ZW'
  }
];

export const countriesByAlpha2: Record<string, any> = {
  AF: {
    name: 'Afghanistan',
    'alpha-2': 'AF',
    'country-code': '004'
  },
  AX: {
    name: 'Åland Islands',
    'alpha-2': 'AX',
    'country-code': '248'
  },
  AL: {
    name: 'Albania',
    'alpha-2': 'AL',
    'country-code': '008'
  },
  DZ: {
    name: 'Algeria',
    'alpha-2': 'DZ',
    'country-code': '012'
  },
  AS: {
    name: 'American Samoa',
    'alpha-2': 'AS',
    'country-code': '016'
  },
  AD: {
    name: 'Andorra',
    'alpha-2': 'AD',
    'country-code': '020'
  },
  AO: {
    name: 'Angola',
    'alpha-2': 'AO',
    'country-code': '024'
  },
  AI: {
    name: 'Anguilla',
    'alpha-2': 'AI',
    'country-code': '660'
  },
  AQ: {
    name: 'Antarctica',
    'alpha-2': 'AQ',
    'country-code': '010'
  },
  AG: {
    name: 'Antigua and Barbuda',
    'alpha-2': 'AG',
    'country-code': '028'
  },
  AR: {
    name: 'Argentina',
    'alpha-2': 'AR',
    'country-code': '032'
  },
  AM: {
    name: 'Armenia',
    'alpha-2': 'AM',
    'country-code': '051'
  },
  AW: {
    name: 'Aruba',
    'alpha-2': 'AW',
    'country-code': '533'
  },
  AU: {
    name: 'Australia',
    'alpha-2': 'AU',
    'country-code': '036'
  },
  AT: {
    name: 'Austria',
    'alpha-2': 'AT',
    'country-code': '040'
  },
  AZ: {
    name: 'Azerbaijan',
    'alpha-2': 'AZ',
    'country-code': '031'
  },
  BS: {
    name: 'Bahamas',
    'alpha-2': 'BS',
    'country-code': '044'
  },
  BH: {
    name: 'Bahrain',
    'alpha-2': 'BH',
    'country-code': '048'
  },
  BD: {
    name: 'Bangladesh',
    'alpha-2': 'BD',
    'country-code': '050'
  },
  BB: {
    name: 'Barbados',
    'alpha-2': 'BB',
    'country-code': '052'
  },
  BY: {
    name: 'Belarus',
    'alpha-2': 'BY',
    'country-code': '112'
  },
  BE: {
    name: 'Belgium',
    'alpha-2': 'BE',
    'country-code': '056'
  },
  BZ: {
    name: 'Belize',
    'alpha-2': 'BZ',
    'country-code': '084'
  },
  BJ: {
    name: 'Benin',
    'alpha-2': 'BJ',
    'country-code': '204'
  },
  BM: {
    name: 'Bermuda',
    'alpha-2': 'BM',
    'country-code': '060'
  },
  BT: {
    name: 'Bhutan',
    'alpha-2': 'BT',
    'country-code': '064'
  },
  BO: {
    name: 'Bolivia',
    'alpha-2': 'BO',
    'country-code': '068'
  },
  BQ: {
    name: 'Bonaire, Sint Eustatius and Saba',
    'alpha-2': 'BQ',
    'country-code': '535'
  },
  BA: {
    name: 'Bosnia and Herzegovina',
    'alpha-2': 'BA',
    'country-code': '070'
  },
  BW: {
    name: 'Botswana',
    'alpha-2': 'BW',
    'country-code': '072'
  },
  BV: {
    name: 'Bouvet Island',
    'alpha-2': 'BV',
    'country-code': '074'
  },
  BR: {
    name: 'Brazil',
    'alpha-2': 'BR',
    'country-code': '076'
  },
  IO: {
    name: 'British Indian Ocean Territory',
    'alpha-2': 'IO',
    'country-code': '086'
  },
  BN: {
    name: 'Brunei Darussalam',
    'alpha-2': 'BN',
    'country-code': '096'
  },
  BG: {
    name: 'Bulgaria',
    'alpha-2': 'BG',
    'country-code': '100'
  },
  BF: {
    name: 'Burkina Faso',
    'alpha-2': 'BF',
    'country-code': '854'
  },
  BI: {
    name: 'Burundi',
    'alpha-2': 'BI',
    'country-code': '108'
  },
  CV: {
    name: 'Cabo Verde',
    'alpha-2': 'CV',
    'country-code': '132'
  },
  KH: {
    name: 'Cambodia',
    'alpha-2': 'KH',
    'country-code': '116'
  },
  CM: {
    name: 'Cameroon',
    'alpha-2': 'CM',
    'country-code': '120'
  },
  CA: {
    name: 'Canada',
    'alpha-2': 'CA',
    'country-code': '124'
  },
  KY: {
    name: 'Cayman Islands',
    'alpha-2': 'KY',
    'country-code': '136'
  },
  CF: {
    name: 'Central African Republic',
    'alpha-2': 'CF',
    'country-code': '140'
  },
  TD: {
    name: 'Chad',
    'alpha-2': 'TD',
    'country-code': '148'
  },
  CL: {
    name: 'Chile',
    'alpha-2': 'CL',
    'country-code': '152'
  },
  CN: {
    name: 'China',
    'alpha-2': 'CN',
    'country-code': '156'
  },
  CX: {
    name: 'Christmas Island',
    'alpha-2': 'CX',
    'country-code': '162'
  },
  CC: {
    name: 'Cocos (Keeling) Islands',
    'alpha-2': 'CC',
    'country-code': '166'
  },
  CO: {
    name: 'Colombia',
    'alpha-2': 'CO',
    'country-code': '170'
  },
  KM: {
    name: 'Comoros',
    'alpha-2': 'KM',
    'country-code': '174'
  },
  CG: {
    name: 'Congo',
    'alpha-2': 'CG',
    'country-code': '178'
  },
  CD: {
    name: 'Congo, Democratic Republic of the',
    'alpha-2': 'CD',
    'country-code': '180'
  },
  CK: {
    name: 'Cook Islands',
    'alpha-2': 'CK',
    'country-code': '184'
  },
  CR: {
    name: 'Costa Rica',
    'alpha-2': 'CR',
    'country-code': '188'
  },
  CI: {
    name: "Côte d'Ivoire",
    'alpha-2': 'CI',
    'country-code': '384'
  },
  HR: {
    name: 'Croatia',
    'alpha-2': 'HR',
    'country-code': '191'
  },
  CU: {
    name: 'Cuba',
    'alpha-2': 'CU',
    'country-code': '192'
  },
  CW: {
    name: 'Curaçao',
    'alpha-2': 'CW',
    'country-code': '531'
  },
  CY: {
    name: 'Cyprus',
    'alpha-2': 'CY',
    'country-code': '196'
  },
  CZ: {
    name: 'Czechia',
    'alpha-2': 'CZ',
    'country-code': '203'
  },
  DK: {
    name: 'Denmark',
    'alpha-2': 'DK',
    'country-code': '208'
  },
  DJ: {
    name: 'Djibouti',
    'alpha-2': 'DJ',
    'country-code': '262'
  },
  DM: {
    name: 'Dominica',
    'alpha-2': 'DM',
    'country-code': '212'
  },
  DO: {
    name: 'Dominican Republic',
    'alpha-2': 'DO',
    'country-code': '214'
  },
  EC: {
    name: 'Ecuador',
    'alpha-2': 'EC',
    'country-code': '218'
  },
  EG: {
    name: 'Egypt',
    'alpha-2': 'EG',
    'country-code': '818'
  },
  SV: {
    name: 'El Salvador',
    'alpha-2': 'SV',
    'country-code': '222'
  },
  GQ: {
    name: 'Equatorial Guinea',
    'alpha-2': 'GQ',
    'country-code': '226'
  },
  ER: {
    name: 'Eritrea',
    'alpha-2': 'ER',
    'country-code': '232'
  },
  EE: {
    name: 'Estonia',
    'alpha-2': 'EE',
    'country-code': '233'
  },
  SZ: {
    name: 'Eswatini',
    'alpha-2': 'SZ',
    'country-code': '748'
  },
  ET: {
    name: 'Ethiopia',
    'alpha-2': 'ET',
    'country-code': '231'
  },
  FK: {
    name: 'Falkland Islands (Malvinas)',
    'alpha-2': 'FK',
    'country-code': '238'
  },
  FO: {
    name: 'Faroe Islands',
    'alpha-2': 'FO',
    'country-code': '234'
  },
  FJ: {
    name: 'Fiji',
    'alpha-2': 'FJ',
    'country-code': '242'
  },
  FI: {
    name: 'Finland',
    'alpha-2': 'FI',
    'country-code': '246'
  },
  FR: {
    name: 'France',
    'alpha-2': 'FR',
    'country-code': '250'
  },
  GF: {
    name: 'French Guiana',
    'alpha-2': 'GF',
    'country-code': '254'
  },
  PF: {
    name: 'French Polynesia',
    'alpha-2': 'PF',
    'country-code': '258'
  },
  TF: {
    name: 'French Southern Territories',
    'alpha-2': 'TF',
    'country-code': '260'
  },
  GA: {
    name: 'Gabon',
    'alpha-2': 'GA',
    'country-code': '266'
  },
  GM: {
    name: 'Gambia',
    'alpha-2': 'GM',
    'country-code': '270'
  },
  GE: {
    name: 'Georgia',
    'alpha-2': 'GE',
    'country-code': '268'
  },
  DE: {
    name: 'Germany',
    'alpha-2': 'DE',
    'country-code': '276'
  },
  GH: {
    name: 'Ghana',
    'alpha-2': 'GH',
    'country-code': '288'
  },
  GI: {
    name: 'Gibraltar',
    'alpha-2': 'GI',
    'country-code': '292'
  },
  GR: {
    name: 'Greece',
    'alpha-2': 'GR',
    'country-code': '300'
  },
  GL: {
    name: 'Greenland',
    'alpha-2': 'GL',
    'country-code': '304'
  },
  GD: {
    name: 'Grenada',
    'alpha-2': 'GD',
    'country-code': '308'
  },
  GP: {
    name: 'Guadeloupe',
    'alpha-2': 'GP',
    'country-code': '312'
  },
  GU: {
    name: 'Guam',
    'alpha-2': 'GU',
    'country-code': '316'
  },
  GT: {
    name: 'Guatemala',
    'alpha-2': 'GT',
    'country-code': '320'
  },
  GG: {
    name: 'Guernsey',
    'alpha-2': 'GG',
    'country-code': '831'
  },
  GN: {
    name: 'Guinea',
    'alpha-2': 'GN',
    'country-code': '324'
  },
  GW: {
    name: 'Guinea-Bissau',
    'alpha-2': 'GW',
    'country-code': '624'
  },
  GY: {
    name: 'Guyana',
    'alpha-2': 'GY',
    'country-code': '328'
  },
  HT: {
    name: 'Haiti',
    'alpha-2': 'HT',
    'country-code': '332'
  },
  HM: {
    name: 'Heard Island and McDonald Islands',
    'alpha-2': 'HM',
    'country-code': '334'
  },
  VA: {
    name: 'Holy See',
    'alpha-2': 'VA',
    'country-code': '336'
  },
  HN: {
    name: 'Honduras',
    'alpha-2': 'HN',
    'country-code': '340'
  },
  HK: {
    name: 'Hong Kong',
    'alpha-2': 'HK',
    'country-code': '344'
  },
  HU: {
    name: 'Hungary',
    'alpha-2': 'HU',
    'country-code': '348'
  },
  IS: {
    name: 'Iceland',
    'alpha-2': 'IS',
    'country-code': '352'
  },
  IN: {
    name: 'India',
    'alpha-2': 'IN',
    'country-code': '356'
  },
  ID: {
    name: 'Indonesia',
    'alpha-2': 'ID',
    'country-code': '360'
  },
  IR: {
    name: 'Iran',
    'alpha-2': 'IR',
    'country-code': '364'
  },
  IQ: {
    name: 'Iraq',
    'alpha-2': 'IQ',
    'country-code': '368'
  },
  IE: {
    name: 'Ireland',
    'alpha-2': 'IE',
    'country-code': '372'
  },
  IM: {
    name: 'Isle of Man',
    'alpha-2': 'IM',
    'country-code': '833'
  },
  IL: {
    name: 'Israel',
    'alpha-2': 'IL',
    'country-code': '376'
  },
  IT: {
    name: 'Italy',
    'alpha-2': 'IT',
    'country-code': '380'
  },
  JM: {
    name: 'Jamaica',
    'alpha-2': 'JM',
    'country-code': '388'
  },
  JP: {
    name: 'Japan',
    'alpha-2': 'JP',
    'country-code': '392'
  },
  JE: {
    name: 'Jersey',
    'alpha-2': 'JE',
    'country-code': '832'
  },
  JO: {
    name: 'Jordan',
    'alpha-2': 'JO',
    'country-code': '400'
  },
  KZ: {
    name: 'Kazakhstan',
    'alpha-2': 'KZ',
    'country-code': '398'
  },
  KE: {
    name: 'Kenya',
    'alpha-2': 'KE',
    'country-code': '404'
  },
  KI: {
    name: 'Kiribati',
    'alpha-2': 'KI',
    'country-code': '296'
  },
  KP: {
    name: "Korea, Democratic People's Republic of",
    'alpha-2': 'KP',
    'country-code': '408'
  },
  KR: {
    name: 'Korea, Republic of',
    'alpha-2': 'KR',
    'country-code': '410'
  },
  KW: {
    name: 'Kuwait',
    'alpha-2': 'KW',
    'country-code': '414'
  },
  KG: {
    name: 'Kyrgyzstan',
    'alpha-2': 'KG',
    'country-code': '417'
  },
  LA: {
    name: "Lao People's Democratic Republic",
    'alpha-2': 'LA',
    'country-code': '418'
  },
  LV: {
    name: 'Latvia',
    'alpha-2': 'LV',
    'country-code': '428'
  },
  LB: {
    name: 'Lebanon',
    'alpha-2': 'LB',
    'country-code': '422'
  },
  LS: {
    name: 'Lesotho',
    'alpha-2': 'LS',
    'country-code': '426'
  },
  LR: {
    name: 'Liberia',
    'alpha-2': 'LR',
    'country-code': '430'
  },
  LY: {
    name: 'Libya',
    'alpha-2': 'LY',
    'country-code': '434'
  },
  LI: {
    name: 'Liechtenstein',
    'alpha-2': 'LI',
    'country-code': '438'
  },
  LT: {
    name: 'Lithuania',
    'alpha-2': 'LT',
    'country-code': '440'
  },
  LU: {
    name: 'Luxembourg',
    'alpha-2': 'LU',
    'country-code': '442'
  },
  MO: {
    name: 'Macao',
    'alpha-2': 'MO',
    'country-code': '446'
  },
  MG: {
    name: 'Madagascar',
    'alpha-2': 'MG',
    'country-code': '450'
  },
  MW: {
    name: 'Malawi',
    'alpha-2': 'MW',
    'country-code': '454'
  },
  MY: {
    name: 'Malaysia',
    'alpha-2': 'MY',
    'country-code': '458'
  },
  MV: {
    name: 'Maldives',
    'alpha-2': 'MV',
    'country-code': '462'
  },
  ML: {
    name: 'Mali',
    'alpha-2': 'ML',
    'country-code': '466'
  },
  MT: {
    name: 'Malta',
    'alpha-2': 'MT',
    'country-code': '470'
  },
  MH: {
    name: 'Marshall Islands',
    'alpha-2': 'MH',
    'country-code': '584'
  },
  MQ: {
    name: 'Martinique',
    'alpha-2': 'MQ',
    'country-code': '474'
  },
  MR: {
    name: 'Mauritania',
    'alpha-2': 'MR',
    'country-code': '478'
  },
  MU: {
    name: 'Mauritius',
    'alpha-2': 'MU',
    'country-code': '480'
  },
  YT: {
    name: 'Mayotte',
    'alpha-2': 'YT',
    'country-code': '175'
  },
  MX: {
    name: 'Mexico',
    'alpha-2': 'MX',
    'country-code': '484'
  },
  FM: {
    name: 'Micronesia',
    'alpha-2': 'FM',
    'country-code': '583'
  },
  MD: {
    name: 'Moldova',
    'alpha-2': 'MD',
    'country-code': '498'
  },
  MC: {
    name: 'Monaco',
    'alpha-2': 'MC',
    'country-code': '492'
  },
  MN: {
    name: 'Mongolia',
    'alpha-2': 'MN',
    'country-code': '496'
  },
  ME: {
    name: 'Montenegro',
    'alpha-2': 'ME',
    'country-code': '499'
  },
  MS: {
    name: 'Montserrat',
    'alpha-2': 'MS',
    'country-code': '500'
  },
  MA: {
    name: 'Morocco',
    'alpha-2': 'MA',
    'country-code': '504'
  },
  MZ: {
    name: 'Mozambique',
    'alpha-2': 'MZ',
    'country-code': '508'
  },
  MM: {
    name: 'Myanmar',
    'alpha-2': 'MM',
    'country-code': '104'
  },
  NA: {
    name: 'Namibia',
    'alpha-2': 'NA',
    'country-code': '516'
  },
  NR: {
    name: 'Nauru',
    'alpha-2': 'NR',
    'country-code': '520'
  },
  NP: {
    name: 'Nepal',
    'alpha-2': 'NP',
    'country-code': '524'
  },
  NL: {
    name: 'Netherlands',
    'alpha-2': 'NL',
    'country-code': '528'
  },
  NC: {
    name: 'New Caledonia',
    'alpha-2': 'NC',
    'country-code': '540'
  },
  NZ: {
    name: 'New Zealand',
    'alpha-2': 'NZ',
    'country-code': '554'
  },
  NI: {
    name: 'Nicaragua',
    'alpha-2': 'NI',
    'country-code': '558'
  },
  NE: {
    name: 'Niger',
    'alpha-2': 'NE',
    'country-code': '562'
  },
  NG: {
    name: 'Nigeria',
    'alpha-2': 'NG',
    'country-code': '566'
  },
  NU: {
    name: 'Niue',
    'alpha-2': 'NU',
    'country-code': '570'
  },
  NF: {
    name: 'Norfolk Island',
    'alpha-2': 'NF',
    'country-code': '574'
  },
  MK: {
    name: 'North Macedonia',
    'alpha-2': 'MK',
    'country-code': '807'
  },
  MP: {
    name: 'Northern Mariana Islands',
    'alpha-2': 'MP',
    'country-code': '580'
  },
  NO: {
    name: 'Norway',
    'alpha-2': 'NO',
    'country-code': '578'
  },
  OM: {
    name: 'Oman',
    'alpha-2': 'OM',
    'country-code': '512'
  },
  PK: {
    name: 'Pakistan',
    'alpha-2': 'PK',
    'country-code': '586'
  },
  PW: {
    name: 'Palau',
    'alpha-2': 'PW',
    'country-code': '585'
  },
  PS: {
    name: 'Palestine, State of',
    'alpha-2': 'PS',
    'country-code': '275'
  },
  PA: {
    name: 'Panama',
    'alpha-2': 'PA',
    'country-code': '591'
  },
  PG: {
    name: 'Papua New Guinea',
    'alpha-2': 'PG',
    'country-code': '598'
  },
  PY: {
    name: 'Paraguay',
    'alpha-2': 'PY',
    'country-code': '600'
  },
  PE: {
    name: 'Peru',
    'alpha-2': 'PE',
    'country-code': '604'
  },
  PH: {
    name: 'Philippines',
    'alpha-2': 'PH',
    'country-code': '608'
  },
  PN: {
    name: 'Pitcairn',
    'alpha-2': 'PN',
    'country-code': '612'
  },
  PL: {
    name: 'Poland',
    'alpha-2': 'PL',
    'country-code': '616'
  },
  PT: {
    name: 'Portugal',
    'alpha-2': 'PT',
    'country-code': '620'
  },
  PR: {
    name: 'Puerto Rico',
    'alpha-2': 'PR',
    'country-code': '630'
  },
  QA: {
    name: 'Qatar',
    'alpha-2': 'QA',
    'country-code': '634'
  },
  RE: {
    name: 'Réunion',
    'alpha-2': 'RE',
    'country-code': '638'
  },
  RO: {
    name: 'Romania',
    'alpha-2': 'RO',
    'country-code': '642'
  },
  RU: {
    name: 'Russian Federation',
    'alpha-2': 'RU',
    'country-code': '643'
  },
  RW: {
    name: 'Rwanda',
    'alpha-2': 'RW',
    'country-code': '646'
  },
  BL: {
    name: 'Saint Barthélemy',
    'alpha-2': 'BL',
    'country-code': '652'
  },
  SH: {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    'alpha-2': 'SH',
    'country-code': '654'
  },
  KN: {
    name: 'Saint Kitts and Nevis',
    'alpha-2': 'KN',
    'country-code': '659'
  },
  LC: {
    name: 'Saint Lucia',
    'alpha-2': 'LC',
    'country-code': '662'
  },
  MF: {
    name: 'Saint Martin (French part)',
    'alpha-2': 'MF',
    'country-code': '663'
  },
  PM: {
    name: 'Saint Pierre and Miquelon',
    'alpha-2': 'PM',
    'country-code': '666'
  },
  VC: {
    name: 'Saint Vincent and the Grenadines',
    'alpha-2': 'VC',
    'country-code': '670'
  },
  WS: {
    name: 'Samoa',
    'alpha-2': 'WS',
    'country-code': '882'
  },
  SM: {
    name: 'San Marino',
    'alpha-2': 'SM',
    'country-code': '674'
  },
  ST: {
    name: 'Sao Tome and Principe',
    'alpha-2': 'ST',
    'country-code': '678'
  },
  SA: {
    name: 'Saudi Arabia',
    'alpha-2': 'SA',
    'country-code': '682'
  },
  SN: {
    name: 'Senegal',
    'alpha-2': 'SN',
    'country-code': '686'
  },
  RS: {
    name: 'Serbia',
    'alpha-2': 'RS',
    'country-code': '688'
  },
  SC: {
    name: 'Seychelles',
    'alpha-2': 'SC',
    'country-code': '690'
  },
  SL: {
    name: 'Sierra Leone',
    'alpha-2': 'SL',
    'country-code': '694'
  },
  SG: {
    name: 'Singapore',
    'alpha-2': 'SG',
    'country-code': '702'
  },
  SX: {
    name: 'Sint Maarten (Dutch part)',
    'alpha-2': 'SX',
    'country-code': '534'
  },
  SK: {
    name: 'Slovakia',
    'alpha-2': 'SK',
    'country-code': '703'
  },
  SI: {
    name: 'Slovenia',
    'alpha-2': 'SI',
    'country-code': '705'
  },
  SB: {
    name: 'Solomon Islands',
    'alpha-2': 'SB',
    'country-code': '090'
  },
  SO: {
    name: 'Somalia',
    'alpha-2': 'SO',
    'country-code': '706'
  },
  ZA: {
    name: 'South Africa',
    'alpha-2': 'ZA',
    'country-code': '710'
  },
  GS: {
    name: 'South Georgia and the South Sandwich Islands',
    'alpha-2': 'GS',
    'country-code': '239'
  },
  SS: {
    name: 'South Sudan',
    'alpha-2': 'SS',
    'country-code': '728'
  },
  ES: {
    name: 'Spain',
    'alpha-2': 'ES',
    'country-code': '724'
  },
  LK: {
    name: 'Sri Lanka',
    'alpha-2': 'LK',
    'country-code': '144'
  },
  SD: {
    name: 'Sudan',
    'alpha-2': 'SD',
    'country-code': '729'
  },
  SR: {
    name: 'Suriname',
    'alpha-2': 'SR',
    'country-code': '740'
  },
  SJ: {
    name: 'Svalbard and Jan Mayen',
    'alpha-2': 'SJ',
    'country-code': '744'
  },
  SE: {
    name: 'Sweden',
    'alpha-2': 'SE',
    'country-code': '752'
  },
  CH: {
    name: 'Switzerland',
    'alpha-2': 'CH',
    'country-code': '756'
  },
  SY: {
    name: 'Syrian Arab Republic',
    'alpha-2': 'SY',
    'country-code': '760'
  },
  TW: {
    name: 'Taiwan',
    'alpha-2': 'TW',
    'country-code': '158'
  },
  TJ: {
    name: 'Tajikistan',
    'alpha-2': 'TJ',
    'country-code': '762'
  },
  TZ: {
    name: 'Tanzania',
    'alpha-2': 'TZ',
    'country-code': '834'
  },
  TH: {
    name: 'Thailand',
    'alpha-2': 'TH',
    'country-code': '764'
  },
  TL: {
    name: 'Timor-Leste',
    'alpha-2': 'TL',
    'country-code': '626'
  },
  TG: {
    name: 'Togo',
    'alpha-2': 'TG',
    'country-code': '768'
  },
  TK: {
    name: 'Tokelau',
    'alpha-2': 'TK',
    'country-code': '772'
  },
  TO: {
    name: 'Tonga',
    'alpha-2': 'TO',
    'country-code': '776'
  },
  TT: {
    name: 'Trinidad and Tobago',
    'alpha-2': 'TT',
    'country-code': '780'
  },
  TN: {
    name: 'Tunisia',
    'alpha-2': 'TN',
    'country-code': '788'
  },
  TR: {
    name: 'Turkey',
    'alpha-2': 'TR',
    'country-code': '792'
  },
  TM: {
    name: 'Turkmenistan',
    'alpha-2': 'TM',
    'country-code': '795'
  },
  TC: {
    name: 'Turks and Caicos Islands',
    'alpha-2': 'TC',
    'country-code': '796'
  },
  TV: {
    name: 'Tuvalu',
    'alpha-2': 'TV',
    'country-code': '798'
  },
  UG: {
    name: 'Uganda',
    'alpha-2': 'UG',
    'country-code': '800'
  },
  UA: {
    name: 'Ukraine',
    'alpha-2': 'UA',
    'country-code': '804'
  },
  AE: {
    name: 'United Arab Emirates',
    'alpha-2': 'AE',
    'country-code': '784'
  },
  GB: {
    name: 'United Kingdom of Great Britain and Northern Ireland',
    'alpha-2': 'GB',
    'country-code': '826'
  },
  US: {
    name: 'United States of America',
    'alpha-2': 'US',
    'country-code': '840'
  },
  UM: {
    name: 'United States Minor Outlying Islands',
    'alpha-2': 'UM',
    'country-code': '581'
  },
  UY: {
    name: 'Uruguay',
    'alpha-2': 'UY',
    'country-code': '858'
  },
  UZ: {
    name: 'Uzbekistan',
    'alpha-2': 'UZ',
    'country-code': '860'
  },
  VU: {
    name: 'Vanuatu',
    'alpha-2': 'VU',
    'country-code': '548'
  },
  VE: {
    name: 'Venezuela',
    'alpha-2': 'VE',
    'country-code': '862'
  },
  VN: {
    name: 'Viet Nam',
    'alpha-2': 'VN',
    'country-code': '704'
  },
  VG: {
    name: 'Virgin Islands (British)',
    'alpha-2': 'VG',
    'country-code': '092'
  },
  VI: {
    name: 'Virgin Islands (U.S.)',
    'alpha-2': 'VI',
    'country-code': '850'
  },
  WF: {
    name: 'Wallis and Futuna',
    'alpha-2': 'WF',
    'country-code': '876'
  },
  EH: {
    name: 'Western Sahara',
    'alpha-2': 'EH',
    'country-code': '732'
  },
  YE: {
    name: 'Yemen',
    'alpha-2': 'YE',
    'country-code': '887'
  },
  ZM: {
    name: 'Zambia',
    'alpha-2': 'ZM',
    'country-code': '894'
  },
  ZW: {
    name: 'Zimbabwe',
    'alpha-2': 'ZW',
    'country-code': '716'
  }
};
